// extracted by mini-css-extract-plugin
export default {"point":"StepPoint_point__tsJPL","active":"StepPoint_active__+04DA","loading":"StepPoint_loading__Xv-oj","complete":"StepPoint_complete__Dfhj1"};